import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { getAppConfig } from './utils/config';
import * as CommandPage from '@scripts/CommandPageConst';

//const basename = process.env.REACT_APP_BASENAME || "/";

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
            registration.unregister()
        });
    });

    // Delete all service worker caches
    console.log('%cStart delete cache', 'color:red;');
    await caches.keys().then((cacheNames) => {
        return Promise.all(
            cacheNames.map((cache) => {
                return caches.delete(cache); //Deleting the cache
            })
        );
    })
    console.log('%cCache deleted!', 'color:green;');

    navigator.serviceWorker.addEventListener('message', (event) => {
        // The data comes from the service worker to indicate a reload page command
        if (event.data && event.data.type === CommandPage.reload_page) {
            window.location.reload();
        }
    });
}

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */

const loadConfig = () => {
    return new Promise(async resolve => {
        await getAppConfig(true);

        resolve();
    })
}

await loadConfig();

const msalParams = await msalConfig();

const msalInstance = new PublicClientApplication(msalParams);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
    }
});

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <App instance={msalInstance} />
    </BrowserRouter>
    ,
    rootElement);

//registerServiceWorker();